import { c as _c } from "react/compiler-runtime";
import { Slot } from "@radix-ui/react-slot";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@repo/blacksmith-ui/cn";
export const CHAT_CARD_SURFACE_CLASS = "rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)]";
export const CHAT_CARD_CLASS = `${CHAT_CARD_SURFACE_CLASS} px-3 py-3`;
export const CHAT_CARD_INTERACTIVE_CLASS = "cursor-pointer transition-colors duration-0 hover:bg-[var(--color-surface-hover)]";
/** Card open in the workspace pane; must follow CHAT_CARD_INTERACTIVE_CLASS in cn() to win the merge. */
export const CHAT_CARD_OPEN_CLASS = "bg-[var(--color-surface-hover)] hover:bg-[var(--color-surface-inset-hover)]";
type ChatCardProps = ComponentPropsWithoutRef<"div"> & {
  asChild?: boolean;
  interactive?: boolean;
};
export function ChatCard(t0) {
  const $ = _c(13);
  let asChild;
  let className;
  let interactive;
  let props;
  if ($[0] !== t0) {
    ({
      asChild,
      interactive,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = asChild;
    $[2] = className;
    $[3] = interactive;
    $[4] = props;
  } else {
    asChild = $[1];
    className = $[2];
    interactive = $[3];
    props = $[4];
  }
  const Comp = asChild ? Slot : "div";
  const t1 = interactive ? true : undefined;
  const t2 = interactive && CHAT_CARD_INTERACTIVE_CLASS;
  let t3;
  if ($[5] !== className || $[6] !== t2) {
    t3 = cn(CHAT_CARD_CLASS, t2, className);
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== Comp || $[9] !== props || $[10] !== t1 || $[11] !== t3) {
    t4 = <Comp data-chat-card={true} data-chat-card-interactive={t1} className={t3} {...props} />;
    $[8] = Comp;
    $[9] = props;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}